"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLifecyclePropertyOptions = getLifecyclePropertyOptions;
exports.isPropertyAllowedInFlows = isPropertyAllowedInFlows;
exports.isPropertyAllowedInFlowsByValue = isPropertyAllowedInFlowsByValue;
exports.filterPropertyList = filterPropertyList;
exports.generatePropertyName = generatePropertyName;
exports.labelToName = labelToName;
exports.isValidNewProperty = isValidNewProperty;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

var MAX_NAME_LENGTH = 99;
var numberAtBeginning = /^[0-9]+/;
var specialCharacters = /[^a-zA-Z0-9]+/g;
var underscoreAtBeginning = /^_+/;

function isPropertyUsable(property) {
  return !property.hidden && !property.readOnlyValue && property.formField;
}

function defaultBadge() {
  return _react.default.createElement("font", {
    className: "defaultLifecycleOption"
  }, _I18n.default.text('leadFlowEditor.leadFlowFormEditor.lifecycles.defaultTag'));
}

function getLifecyclePropertyOptions(property) {
  return property.options.map(function (option) {
    return {
      value: option.value,
      text: _I18n.default.text("leadFlowEditor.leadFlowFormEditor.lifecycles.stages." + option.value),
      badge: option.value === 'lead' ? defaultBadge() : null
    };
  });
}

function isPropertyAllowedInFlows(property) {
  return property.type === 'string' && property.fieldType === 'text' || property.type === 'number' && property.fieldType === 'number' || property.type === 'enumeration' && property.fieldType === 'booleancheckbox' || property.type === 'string' && property.fieldType === 'textarea' || property.type === 'enumeration' && property.fieldType === 'select' || property.type === 'date' && property.fieldType === 'date' || property.type === 'string' && property.fieldType === 'file';
}

function isPropertyAllowedInFlowsByValue(property) {
  return property.value === 'text' || property.value === 'textarea' || property.value === 'select' || property.value === 'booleancheckbox' || property.value === 'number' || property.value === 'date' || property.value === 'file';
}

function filterPropertyList(_ref) {
  var properties = _ref.properties,
      groups = _ref.groups;
  var usableProperties = (0, _underscore.filter)(properties, isPropertyUsable);
  var usableGroupNames = (0, _underscore.unique)((usableProperties || []).map(function (el) {
    return el.groupName;
  }));
  var usableGroups = (0, _underscore.filter)(groups, function (group) {
    return (0, _underscore.contains)(usableGroupNames, group.name);
  });
  return {
    properties: usableProperties,
    groups: usableGroups
  };
}

function generatePropertyName(label) {
  return label.trim().replace( // Anything that isn't alphanumerical or _ gets replaced.
  /[^a-zA-Z0-9_]/g, '_').replace( // Ensure there aren't multiple sequential underscores.
  /_+/g, '_').toLowerCase();
}

function labelToName(label) {
  return label.trim().toLowerCase().replace(specialCharacters, '_').replace(underscoreAtBeginning, '').replace(numberAtBeginning, 'n$&').slice(0, MAX_NAME_LENGTH);
}

function isValidNewProperty(label, existingProperties) {
  var name = generatePropertyName(label); // Cannot match any existing property.

  return !(0, _underscore.any)(existingProperties, function (property) {
    return property.name.toLowerCase() === name.toLowerCase() || property.label.toLowerCase() === label.toLowerCase();
  });
}